// Константы для api/hooks — централизованное место, чтобы не плодить magic numbers.

/** Максимум попыток task'а: initial + 3 retry = 4 total.
 *  Соответствует backend `apps/generations/base.py:max_retries=3` (PRD §4.6). */
export const MAX_TASK_ATTEMPTS = 4;

/** Максимум попыток корректуры («Попытка N/2» на экране ожидания) — ДВЕ,
 *  а не общий MAX_TASK_ATTEMPTS. ЗЕРКАЛО backend — МЕНЯТЬ ВМЕСТЕ: число
 *  попыток = число конфигураций `PROOFREADER_ATTEMPTS` в
 *  `backend/apps/generations/tasks.py` (сейчас две модели: gemini + Luna
 *  Pro), где `CorrectTextTask.max_retries = 1` даёт ровно один повтор поверх
 *  начальной попытки → 2 попытки суммарно. Автоматической синхронизации нет
 *  (задачи «Корректура» не используют MAX_TASK_ATTEMPTS) — при изменении
 *  числа моделей/max_retries на backend синхронизировать это значение вручную. */
export const PROOFREADER_MAX_ATTEMPTS = 2;

/** Polling интервалы (PRD §11.6): 2s × 10 → 3s × 10 → 5s ∞. */
export const POLL_FAST_MS = 2_000;
export const POLL_MID_MS = 3_000;
export const POLL_SLOW_MS = 5_000;

/** axios request timeout (30s достаточно для generate-эндпоинта, который
 *  возвращает task_id сразу — реальная генерация в Celery, не блокирует HTTP). */
export const API_TIMEOUT_MS = 30_000;

/** Кэш конфигурации tool'а — статика, обновляется редко. */
export const TOOL_CONFIG_STALE_MS = 5 * 60_000;
export const TOOL_CONFIG_GC_MS = 30 * 60_000;

/** Кэш /me/ — короткий staleTime, чтобы Sidebar обновлялся при изменении прав
 *  в admin без F5 (если refetchOnWindowFocus сработает). */
export const ME_STALE_MS = 30_000;

/** Максимальная длина display name пользователя в UI — защита от RTL-override,
 *  ZWJ-spam и просто длинных строк, ломающих layout Header'а. */
export const DISPLAY_NAME_MAX_CHARS = 64;

/** localStorage namespace prefix. Дублируется в hooks/useLocalStorage.ts
 *  как `LS_NAMESPACE` — единственная зависимость для consistency. */
export const LS_NAMESPACE = "multitool:";

/** Сигнальный ключ для cross-tab logout propagation. При logout пишем
 *  timestamp; другие вкладки реагируют на storage event этим ключом. */
export const AUTH_SIGNAL_KEY = `${LS_NAMESPACE}auth_signal`;
